(()=>{
  const instances=new Map();
  const init=()=>{
    document.querySelectorAll('[data-uf-header]').forEach(header=>{
      if(instances.has(header))return;
      const controller=new AbortController(),signal=controller.signal;
      const button=header.querySelector('[data-uf-menu-toggle]');
      const nav=button?document.getElementById(button.getAttribute('aria-controls')):null;
      const desktop=matchMedia('(min-width: 768px)');
      const close=(restoreFocus=false)=>{
        nav?.classList.remove('is-open');button?.setAttribute('aria-expanded','false');
        header.querySelectorAll('details[open]').forEach(details=>details.open=false);
        if(restoreFocus)button?.focus();
      };
      const sync=()=>{
        close();
        header.querySelectorAll('[data-uf-search-types]').forEach(select=>select.disabled=!desktop.matches&&select.dataset.mobileVisible!=='true');
      };
      button?.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';if(!open)close();else{nav?.classList.add('is-open');button.setAttribute('aria-expanded','true')}},{signal});
      header.addEventListener('keydown',event=>{
        if(event.key!=='Escape')return;
        const disclosure=event.target.closest('details[open]');
        if(disclosure){disclosure.open=false;disclosure.querySelector('summary')?.focus();event.stopPropagation();return;}
        if(button?.getAttribute('aria-expanded')==='true'){close(true);event.preventDefault();}
      },{signal});
      nav?.addEventListener('click',event=>{if(event.target.closest('a')&&!desktop.matches)close()},{signal});
      document.addEventListener('click',event=>{if(!header.contains(event.target))close()},{signal});
      header.addEventListener('focusout',event=>{if(event.relatedTarget&&!header.contains(event.relatedTarget))close()},{signal});
      header.addEventListener('toggle',event=>{
        const details=event.target;if(!details.matches('details')||!details.open)return;
        header.querySelectorAll('details[open]').forEach(other=>{if(other!==details&&!other.contains(details)&&!details.contains(other))other.open=false});
      },{signal,capture:true});
      desktop.addEventListener('change',sync);
      signal.addEventListener('abort',()=>desktop.removeEventListener('change',sync),{once:true});
      instances.set(header,{controller,close});sync();
    });
  };
  init();document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>{
    for(const [header,instance] of instances){if(event.target===header||event.target.contains(header)||!header.isConnected){instance.controller.abort();instances.delete(header)}}
  });
})();
